<template>
  <div class="test-search-input w-full relative">
    <vs-icon class="absolute mt-3 ml-2 z-10 text-gray-table" icon="search" size="1.4rem"/>
    <base-input :disabled="isDisabled"
                :value="value"
                class="h-12"
                placeholder="Search"
                :variant="variant"
                @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
export default {
  name: 'SearchInput',

  props: {
    value: {
      type: String,
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default:'search'
    }
  }
}
</script>
